<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="content-modal-container">
                <div class="modal-header">
					<div class="modal-title">
						Редактировать папку
					</div>

					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>

				<div class="modal-body">
                    <div class="mb-4">
                        <label class="form-label">Название папки <span class="color-red">*</span></label>
                        <input type="text" class="form-control" placeholder="..." v-model="itemToUpdate.title">
                    </div>
				</div>

                <div class="modal-footer">
                    <button @click="handleEditFolder" class="btn btn-md btn-primary me-2" type="button">
                        <span>Сохранить</span>
                    </button>
                    <button @click="closeModal" class="btn btn-md btn-outline-dark" type="button">
                        <span>Отменить</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <Alert />
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex/dist/vuex.cjs.js';
    import Alert from '../components/alerts/Alert.vue';

    export default {
        name: 'EditFolderModal',
        components: { Alert },

        data() {
            return {
                title: ''
            }
        },

        computed: {
            ...mapState('content', ['itemToUpdate'])
        },

        methods: {
            ...mapMutations('alerts', ['addAlert']),
            ...mapMutations('content', ['closeEditFolderModal']),
            ...mapActions('content', ['editFolder']),

            closeModal() {
                this.itemToUpdate.title = this.title;
                this.closeEditFolderModal();
            },

            handleEditFolder() {
                if (!this.itemToUpdate.title.length) {
                    this.addAlert({ type: 'warning', title: 'Предупреждение', text: 'Введите название папки' });
                    return
                }
                this.editFolder();
            }
        },

        mounted() {
            this.title = this.itemToUpdate.title;
        }
    }

</script>

<style scoped lang="scss">

</style>
